import "../scss/fortune.scss";

const flipClass = 'is-flipped';

const getReadingType = () => {
	const readingType = document.querySelector("input[name='reading-type']:checked");
	return readingType.value;
}

const setStartCardReading = () => {
	const startTrigger = document.querySelector(".start-card-reading");
	if (startTrigger) {
		startTrigger.addEventListener('click', function(e) {
			e.preventDefault();
			scrollToTableTop();
			
			const description = document.querySelector(".fortune-description");
			if (description) {
				description.remove();
			}
			const cardTools = document.querySelector(".card-tools");
			if (cardTools) cardTools.style.display = "block";
			
			setReadingDisplay();
		});
	}
}

const setReadingDisplay = (title, description) => {
	const instructions = document.getElementById("instructions");
	if (instructions) {
		instructions.style.display = "block";
	}
}

const setCardFlip = () => {
	const cardFlipTriggers = document.querySelectorAll("#card-spread .card-holder");
	for (var i = 0; i < cardFlipTriggers.length; i++) {
		const card = cardFlipTriggers[i];
		const cardCollection = card.closest(".card-collection");
		card.addEventListener('click', function(e){
			if (!cardCollection.classList.contains(flipClass)) {
			cardCollection.classList.add(flipClass);
			} 
		});
	}
}

const applyReadingTypeClass = (type) => {
	const className = (type == 1) ? "single-draw" : "past-present-future";
	document.getElementById("card-spread").dataset.readingType = className;
}

const setDealTrigger = () => {
	const dealTrigger = document.querySelector(".deal-cards");
	if (dealTrigger) {
		dealTrigger.addEventListener('click', function(e){
			if (dealTrigger.classList.contains("disabled") || dealTrigger.classList.contains("loading")) return false;
			applyReadingTypeClass(getReadingType());
			shuffle(getReadingType());
			scrollToTableTop();
		});
	}
}

function randomReverseCard(deckCount) {
    const num = Math.floor(Math.random() * deckCount);
    const reverseTarget = deckCount*.5;
    if (num >= reverseTarget) return true;
    else return false;
}

const flipToBack = (cardSpread) => {
	return new Promise(function(resolve, reject) {
		const cardHolders = cardSpread.querySelectorAll("#card-spread .card-collection");
		
		if (!cardHolders.length) resolve();
		
		for (var i = 0; i < cardHolders.length; i++) {
			cardHolders[i].classList.remove(flipClass);
	  	}
	  	setTimeout(() => { 
	    	resolve();
		}, 500);
 	});
}

const shakeDeck = (cardSpread) => {
	cardSpread.classList.add("shuffle-animation");
	return new Promise(function(resolve, reject) {
		setTimeout(() => { 
		    cardSpread.classList.remove("shuffle-animation");
		    resolve();
		}, 1000);
 	});
}

const getCardData = async () => {
    const response = await fetch('/wp-content/themes/goblin/assets/data/cards.json?v=8');
    const cards = await response.json();
    return cards;
  }

  const buildGuideIndex = async () => {
	const cardIndex = document.getElementById("card-index");
	if (cardIndex) {
		getCardData().then(cardData => {
			let html = "<ul>";
			cardData.cards.forEach((card, index) => {
				const cardIndex = index + 1;
				const cardIndexHTML = `
					<li><a href="#card-guide-${cardIndex}" class="card-detail-trigger">${cardIndex}: ${card.title}</a></li>
				`;
				html += cardIndexHTML;
			});
			html += "</ul>";
			cardIndex.innerHTML = html;
			setGuideIndexTriggers();
		});
		
	}
}


const setGuideIndexTriggers = () => {
	const indexTriggers = document.querySelectorAll(".card-detail-trigger");
    for (var i = 0; i < indexTriggers.length; i++) {
        const indexAnchor = indexTriggers[i];  
	
		indexAnchor.addEventListener('click', function(e){
			e.preventDefault();
			const targetSelector = this.getAttribute('href');;
			const target = document.querySelector(targetSelector);
			target.scrollIntoView(); 
        });
    } 
}

const createCardGuideContainer = (title, frontUrl, keywords, reading, reversedReading) => {
	const cardHTML = `
    	<div class="row align-items-lg-center">
			<div class="guide-card-image col-3 col-md-auto">
				<div class="card-container-guide card-lightbox">
					<a href='${frontUrl}' class='view-card' data-sub-html='${keywords}'><img src="${frontUrl}" class="img-fluid" alt="${title}"></a>
				</div>
			</div>							
			<div class="guide-reading col">
				<div class="reading">	
					<h5>Standard Reading</h5>
					<p>${reading}</p>
				</div>
				<div class="reading">	
					<h5>Reversed Reading</h5>
					<p>${reversedReading}</p>
				</div>
			</div>
		</div>
	`;
	return cardHTML
}

const buildGuide = async () => {
	const cardGuide = document.getElementById("card-readings");
	if (cardGuide) {
		getCardData().then(cardData => {
	        let html = "<div class='row justify-content-center'>";
	        cardData.cards.forEach((card, index) => {
		        const cardIndex = index + 1;
		       
	        	const cardHTML = `
	        		
		        	<div id="card-guide-${cardIndex}" class="card-guide-detail col-12 col-md-6">
		        		<h4>${card.title}</h4>
						<h5 class='keywords'>${card.keywords}</h5>
						${createCardGuideContainer(card.title, card.front, card.keywords, card.reading, card.reversed)}
		        	</div>
		        
				`;
	        html += cardHTML;
	    	});
			html += "</div>"
			document.getElementById("card-readings").innerHTML = html;
			setLightGallery("#card-readings");
		});		
	}
}

const buildDeck = async () => {
	const cardDeck = document.getElementById("card-deck");	

	if (cardDeck) {
		getCardData().then(cardData => {
	        const cardBackImage = cardData.back;
	        let html = "";        
	        cardData.cards.forEach(card => {
	        	const cardHTML = `
		        	<div class="card-collection col-12 col-md-6 col-lg-4 col-xl-3">
			        	<div class="card-container">
				        	<div class="card-holder">
								<img src="${cardBackImage}" class="img-fluid oracle-card card-back" alt="${card.title} card back">
								<img src="${card.front}" class="img-fluid oracle-card card-front" alt="${card.title} card front">
							</div>
						</div>
						
						<div class="card-reading">
							<div class="standard-reading">
								${card.reading}
							</div>
							<div class="reverse-reading">
								${card.reversed}
							</div>
						</div>
						
		        	</div>
				`;
	        html += cardHTML;
	    	});
			document.getElementById("card-deck").innerHTML = html;
		});	
	}
}

const scrollToTableTop = () => {
	const cardTable = document.getElementById("oracle-reading-table");
	cardTable.scrollIntoView({ behavior: "instant" });
}

function shuffle(cardsToDraw) {
  	const cardDeck = document.getElementById("card-deck").cloneNode(true);
  	const cardSpread = document.getElementById("card-spread");
  	const allowReverseCard = document.getElementById("allow-reverse").checked;
  	let cardCollection = cardDeck.getElementsByClassName('card-collection');
	
  	cardSpread.classList.remove("hidden");
  	
	const dealTrigger = document.querySelector(".deal-cards");
	dealTrigger.classList.add("loading");
	dealTrigger.textContent = dealTrigger.dataset.loadingText;

  	flipToBack(cardSpread).then(() => {
	  	cardSpread.innerHTML = "";
	  	let deck = Array.prototype.slice.call(cardCollection);
	  	shuffleArray(deck);
	  	const topThree = deck.slice(0, cardsToDraw);
		topThree.forEach(function(element){
	  		if (randomReverseCard(deck.length) && allowReverseCard) element.classList.add("reverse");
			cardSpread.appendChild(element);
		});
		shakeDeck(cardSpread).then(()=> {
			setCardFlip();
			dealTrigger.classList.remove("loading");
			dealTrigger.textContent = dealTrigger.dataset.readyText;
  		});	
  	});
}


function shuffleArray(array) {
    for (var i = array.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = array[i];
        array[i] = array[j];
        array[j] = temp;
    }
    return array;
}

function get_browser() {
	var ua=navigator.userAgent,tem,M=ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []; 
    if(/trident/i.test(M[1])){
        tem=/\brv[ :]+(\d+)/g.exec(ua) || []; 
        return {name:'IE',version:(tem[1]||'')};
        }   
    if(M[1]==='Chrome'){
        tem=ua.match(/\bOPR|Edge\/(\d+)/)
        if(tem!=null)   {return {name:'Opera', version:tem[1]};}
        }   
    M=M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
    if((tem=ua.match(/version\/(\d+)/i))!=null) {M.splice(1,1,tem[1]);}
    return {
      name: M[0],
      version: M[1]
    };
}

const setBrowserDetect = () => {
	const browser=get_browser(); 
	if  (browser.name === "Safari" && browser.version < '15') {
		const body = document.body;
		body.classList.add("no-animation");
	}                        
}
document.addEventListener("DOMContentLoaded", (event) => {
	setBrowserDetect();
	buildDeck();
	buildGuide();
	buildGuideIndex();
	setDealTrigger();
	setStartCardReading();
});